{
  "title": "Enrichment statistics",
  "ciType": "CI type",
  "useLastEnrichment": "Last Entichment",
  "cleanTable": "Clean the table",
  "ciTypesTable": {
    "columns": {
      "ci": "CI",
      "attributes": "Attributes",
      "links": "Links",
      "record": "Record",
      "timestamp": "Date",
      "progress": "Progress"
    }
  },
  "import": {
    "columns": {
      "status": "Status",
      "resource_type": "Resource type",
      "actions_conflict": "Actions for conflict",
      "message": "Message"
    },
    "statuses": {
      "new": "New",
      "success": "Success",
      "skipped": "Skipped",
      "conflict": "Conflict",
      "error": "Error"
    },
    "messages": {
      "common_action": "Choose common action",
      "placeholder": "New name",
      "entities": {
        "cit": "CIT",
        "enrichment_plan": "Enrichment plan",
        "attribute": "Attribute",
        "dashboard": "Dashboard",
        "monitoring_template": "Monitoring template",
        "job": "Job",
        "hi_type": "Health indicator type"
      },
      "conflict_actions": {
        "replace": "Resource updated successfully",
        "rename": "Resource renamed successfully",
        "success": "Resource created successfully",
        "error": "An unknown error occurred",
        "skipped": "Import skipped by user",
        "canceled": "Import canceled"
      },
      "options": {
        "skip": "Skip action",
        "replace": "Replace existing",
        "rename": "Rename"
      }
    }
  }
}